export function Forms(){ }
//valida correo
export function mail(email=""){
    if (!email || typeof email !== 'string') {
        return { estatus: false, mensaje: "Email requerido" };
    }
    
    // Regex estándar para validación de email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
        return { estatus: false, mensaje: "Formato de email inválido" };
    }
    
    return { estatus: true, mensaje: "" };
}
export function text(txt= "", min= 0, max= 0){
    if(txt.length){
        if(txt.length >= min &&  txt.length <= max ){ return true;  }
        if(txt.length  < min ||  txt.length > max  ){ return false; }
    }else{ return false; }
}

export function password(str= ""){
  let mensajePass="";
        if (str.length < 8) { mensajePass= 'Al menos 8 caracteres' }
        if (str.search(/\d/) == -1) { mensajePass= mensajePass.length ?mensajePass+', numeros': 'numeros'}
        if (str.search(/[a-z]/) == -1) { mensajePass= mensajePass.length ?mensajePass+', minusculas': 'minusculas'}
        if (str.search(/[A-Z]/) == -1) { mensajePass= mensajePass.length ?mensajePass+', MAYUSCULAS': 'MAYUSCULAS'}
        if (str.search(/[.#!$%&@.;:_{}+<>()=?¿¡\[\]\-*"]/) == -1) { mensajePass= mensajePass.length ?mensajePass+', caracteres especiales': 'caracteres especiales'}
        if( mensajePass.length ){
          mensajePass='El password debe tener: '+ mensajePass;
        }
        return mensajePass;
}

export function disabledSave(valid){
    let band= false;
    Object.keys(valid).forEach(key =>{ if( !valid[key]){ band=true; } });
    if(band){ return true }else{ return false }
}

export default Forms;
